export const NonNegative = {
    zero: ()=>[
            'non_negative',
            0
        ],
    create: (value)=>[
            'non_negative',
            value !== null && value !== void 0 ? value : 0
        ],
    decrement: ([, value])=>[
            'non_negative',
            value - 1 > -1 ? value : 0
        ],
    increment: ([, value])=>[
            'non_negative',
            value + 1
        ],
    is_zero: ([, value])=>value === 0
};
